import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { trackEvent } from '@kcd/event-tracker';

import { useRouterIsReady } from '~/hooks/url';
import { useStoreBusinessId } from '~/hooks/useBusinessId';
import usePostMessage from '~/hooks/usePostMessage';
import { getEventQuery } from '~/utils/url';

export function HomeTracker() {
  const isRouterReady = useRouterIsReady();
  const router = useRouter();
  const properties = usePostMessage() || {};
  useStoreBusinessId();

  useEffect(() => {
    if (!isRouterReady) {
      return;
    }
    trackEvent('캐시노트마켓 Opened', {
      query: router.query,
      ...getEventQuery(properties),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRouterReady]);

  return null;
}
